export const IWorkingHours = {
  mon: [
    {
      start: '09:00',
      end: '20:00',
      'cut-off': '20:00',
    },
  ],
  tue: [
    {
      start: '09:00',
      end: '20:00',
      'cut-off': '20:00',
    },
  ],
  wed: [
    {
      start: '09:00',
      end: '20:00',
      'cut-off': '20:00',
    },
  ],
  thu: [
    {
      start: '09:00',
      end: '20:00',
      'cut-off': '20:00',
    },
  ],
  fri: [
    {
      start: '09:00',
      end: '20:00',
      'cut-off': '20:00',
    },
  ],
  sat: [
    {
      start: '09:00',
      end: '20:00',
      'cut-off': '20:00',
    },
  ],
  sun: [
    {
      start: '09:00',
      end: '20:00',
      'cut-off': '20:00',
    },
  ],
}

export const IStore = {
  id: 22,
  name: 'My Business',
  business_id: 20,
  business_type: 0,
  website: '',
  description: '',
  emails: [{ email: 'b191@rezasamiei.com', dep: 0 }],
  contact_numbers: {},
  working_hours: IWorkingHours,
  working_hours_note: '',
  address_line1: '',
  address_line2: '',
  address_city: '',
  address_postcode: '',
  country_code: 'uk',
  company_number: '',
  vat_number: '',
  fiscal_year: '0415',
  timezone: 'Europe/London',
  currency_code: 'gbp',
  language_code: 'en-gb',
  terms_and_conditions_url: '',
  privacy_policy_url: '',
  last_user_id: 0,
  is_archive: false,
  created_at: '2023-09-15T07:23:11.593Z',
  updated_at: '2023-09-15T07:23:11.593Z',
  archived_at: null,
}
